import { createReducer, on } from '@ngrx/store';

import { PagedBase } from '../general/models/general';
import { CaseById, SupportCenter } from './models/SupportCenter';
import * as actions from './support-center.actions';

export const SUPPORT_CENTER_FEATURE_KEY = 'supportcenter';

export interface SupportCenterState extends PagedBase {
  supportCenter: SupportCenter[];
  caseById: CaseById;
  message: string;
  isLoading?: boolean;
}

export const initialState: SupportCenterState = {
  supportCenter: [],
  caseById: null,
  message: '',
  isLoading: false,
  hasMore: false,
  pageNumber: 1,
  pageSize: 0,
  totalCount: undefined,
  totalPages: 0,
};

export const supportCenterReducer = createReducer(
  initialState,
  on(actions.getSupportCenter, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(actions.getSupportCenterSuccess, (state, { supportCenter }) => ({
    ...state,
    ...supportCenter,
    supportCenter:
      supportCenter.pageNumber === 1
        ? [...supportCenter.items]
        : [...state.supportCenter, ...supportCenter.items],
  })),
  on(actions.getSupportCenterFailure, (state) => ({
    ...state,
    isLoading: false,
  })),
  on(actions.createSupportCase, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(actions.createSupportCaseSuccess, (state, { message }) => ({
    ...state,
    isLoading: false,
    message,
  })),
  on(actions.createSupportCaseFailure, (state) => ({
    ...state,
    isLoading: false,
  })),
  on(actions.getCaseById, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(actions.getCaseByIdSuccess, (state, { caseById }) => ({
    ...state,
    isLoading: false,
    caseById,
  })),
  on(actions.getCaseByIdFailure, (state) => ({
    ...state,
    isLoading: false,
  })),
  on(actions.replyToCase, (state) => ({ ...state, isLoading: true })),
  on(actions.replyToCaseSuccess, (state, { reply }) => ({
    ...state,
    isLoading: false,
    caseById: state.caseById
      ? {
          ...state.caseById,
          replies: [...state.caseById.replies, reply],
          replyCount: state.caseById.replyCount + 1,
        }
      : state.caseById,
  })),
  on(actions.replyToCaseFailure, (state) => ({ ...state, isLoading: false })),
  on(actions.closeCase, (state) => ({ ...state, isLoading: true })),
  on(actions.closeCaseSuccess, (state) => ({
    ...state,
    isLoading: false,
  })),
  on(actions.closeCaseFailure, (state) => ({ ...state, isLoading: false })),
);
